import { render } from "./vappletadvertadd.vue?vue&type=template&id=383fcf8a&scoped=true"
import script from "./vappletadvertadd.vue?vue&type=script&lang=js"
export * from "./vappletadvertadd.vue?vue&type=script&lang=js"

import "./vappletadvertadd.vue?vue&type=style&index=0&id=383fcf8a&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-383fcf8a"]])

export default __exports__